import React from "react";
import { classnames } from "@culturehq/components";
import { SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";

import { Trans } from "app/utils";

import { CurrentOption } from "./EffectsSDKCameraRecorder";
import PrompterIcon from "../icons/PrompterIcon";

interface PrompterOptionProps {
  isDisableOption: (option: CurrentOption) => boolean;
  onShowScriptChange: (value: string | SelectValueWithCategory | null) => void;
  showScript: boolean;
  screenRecord: boolean;
}

const PrompterOption: React.FC<PrompterOptionProps> = ({
  isDisableOption,
  onShowScriptChange,
  screenRecord,
  showScript
}) => (
  <div
    data-testid="prompter-option"
    className={classnames(
      "Options-Container__effects",
      isDisableOption("prompter") ? "disabled" : "",
      !isDisableOption("prompter") && !showScript ? "inactive" : "")}
    onClick={() => {
      if (!screenRecord) onShowScriptChange(showScript ? "no" : "yes");
    }}
  >
    <div
      data-testid="prompter-option-button"
      className="option"
    >
      <div className="icon-container">
        <PrompterIcon className="icon-container__icon" />
      </div>
      <span className="option-legend"><Trans>Prompter</Trans></span>
    </div>
  </div>
);

export default PrompterOption;
